<ng-container *transloco="let t;">
  <div>
    <div class="row g-0 mb-2">
      <div class="col-auto" #switchWrapper>
        <ng-content></ng-content>
        @if (switchRef()) {
          <ng-container [ngTemplateOutlet]="switchRef()" />
        }
      </div>
      <div class="col-auto">
        <h6 class="section-title">
          @if (hasControl()) {
            <label class="reset-label" [for]="elementId()">{{title()}}</label>
          } @else {
            {{title()}}
          }
        </h6>
      </div>
    </div>


    @if (subtitle()) {
      <div class="text-muted mt-2" [innerHTML]="subtitle()! | safeHtml"></div>
    }
  </div>
</ng-container>
